type FeatureFlags = {
  [key: string]: boolean;
}

export const FEATURE_FLAGS: FeatureFlags = {
  example: false,
};

export type FeatureNames = keyof typeof FEATURE_FLAGS;
